import { render, staticRenderFns } from "./KycSetAccess.vue?vue&type=template&id=21ddabc0"
import script from "./KycSetAccess.vue?vue&type=script&lang=js"
export * from "./KycSetAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports